module.exports = __webpack_public_path__ + "static/media/info-icon.c4cb8853.svg";